/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SetB2BProgramRequest as B2BServiceContractSetB2BProgramRequest } from '../models/B2bService/Contract/set-b-2-b-program-request';

@Injectable({
  providedIn: 'root',
})
export class ProgramService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiB2BSetB2BProgramPost
   */
  static readonly ApiB2BSetB2BProgramPostPath = '/api/B2b/SetB2bProgram';

  /**
   * Editing b2b programs.
   *
   * When setting NULL parameters
   *  i_curr_discount_rate, i_next_discount_rate, i_curr_fee_rate, i_next_fee_rate data
   * are removed from the corresponding tables.
   * If the value of these parameters is not NULL, the data is added/updated.
   * ### Claim
   *  boservice.b2b.setb2bprogram
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BSetB2BProgramPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiB2BSetB2BProgramPost$Response(params?: {

    /**
     * Interface language
     */
    lang?: string;
    body?: B2BServiceContractSetB2BProgramRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProgramService.ApiB2BSetB2BProgramPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Editing b2b programs.
   *
   * When setting NULL parameters
   *  i_curr_discount_rate, i_next_discount_rate, i_curr_fee_rate, i_next_fee_rate data
   * are removed from the corresponding tables.
   * If the value of these parameters is not NULL, the data is added/updated.
   * ### Claim
   *  boservice.b2b.setb2bprogram
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BSetB2BProgramPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiB2BSetB2BProgramPost(params?: {

    /**
     * Interface language
     */
    lang?: string;
    body?: B2BServiceContractSetB2BProgramRequest
  },
  context?: HttpContext

): Observable<void> {

    return this.apiB2BSetB2BProgramPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
